import { db } from './firebase';
import { collection, getDocs } from 'firebase/firestore';

let cache = null;
let fetchPromise = null;

export async function getAllBrackets() {
  if (cache) return cache;
  if (fetchPromise) return fetchPromise;
  fetchPromise = getDocs(collection(db, 'brackets'))
    .then(snap => {
      cache = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      fetchPromise = null;
      return cache;
    });
  return fetchPromise;
}

export function clearBracketCache() {
  cache = null;
  fetchPromise = null;
}